<div class="one" [formGroup]="SettingForm" fxLayout="column">
  <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto" class="mb-3">
    <mat-form-field
      appearance="outline"
      class="estimate-input pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.ESTIMATEWARNINGPERCENT),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.ESTIMATEWARNINGPERCENT),
      }"
    >
      <mat-label>Estimate Warning %</mat-label>
      <input
        type="number"
        placeholder="Estimate Warning % "
        name="ESTIMATEWARNINGPERCENT"
        formControlName="ESTIMATEWARNINGPERCENT"
        matInput
      />
    </mat-form-field>
    <mat-checkbox
      fxLayoutAlign="center"
      class="check_1 estimate-input-1 pr-1"
      name="ALLOWESTIMATERANGE"
      formControlName="ALLOWESTIMATERANGE"
    >
      Allow Estimate Range
    </mat-checkbox>
    <mat-checkbox
      fxLayoutAlign="center"
      class="check_1 text-disp estimate-input-1 pr-1"
      name="USEHIGHESTIMATEFORWARNING"
      formControlName="USEHIGHESTIMATEFORWARNING"
    >
      Use the High Estimate for warnings
    </mat-checkbox>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    For matters where the estimate is over a certain value set a different warning percentage.
  </div>
  &nbsp;
  <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      class="estimate-input-1 pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.ESTIMATENEXTTHRESHOLD),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.ESTIMATENEXTTHRESHOLD),
      }"
    >
      <mat-label>Matters above a certain Estimate {{ CurrenctSymbol }}</mat-label>
      <input
        placeholder="Matters above a certain Estimate $"
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        [leadZero]="true"
        name="ESTIMATENEXTTHRESHOLD"
        formControlName="ESTIMATENEXTTHRESHOLD"
        matInput
      />
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      class="estimate-input-1 pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.ESTIMATENEXTWARNINGPERCENT),
        'has-warning': $safeNavigationMigration(
          errorWarningData.Warning?.ESTIMATENEXTWARNINGPERCENT
        ),
      }"
    >
      <mat-label>Higher Estimate Warning %</mat-label>
      <input
        type="number"
        placeholder="Higher Estimate Warning % "
        name="ESTIMATENEXTWARNINGPERCENT"
        formControlName="ESTIMATENEXTWARNINGPERCENT"
        matInput
      />
    </mat-form-field>
  </div>
  <div class="pt-4">
    <mat-dialog-actions class="popup_ftr justify-end!">
      <button
        id="callApiId"
        class="mainbtn_size"
        matButton="filled"
        [disabled]="isspiner"
        (click)="saveEstimates()"
      >
        @if (isspiner) {
          <mat-spinner diameter="24"></mat-spinner>
        }
        Save
      </button>
      <!-- <button class="btn_2" mat-raised-button color="primary" cdkFocusInitial>Don't Save</button> -->
    </mat-dialog-actions>
  </div>
  <!-- <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
  </div> -->
  <!-- <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

</div> -->
</div>
